import ApiResponse from "sr/models/ApiResponse";
import { get } from "sr/utils/axios";
import { HandleApiError } from "sr/helpers/functions/HandleApiError";
export const getCleaner = async (queryParams) => {
  try {
        return await get<ApiResponse<[]>>(`/cleaner?${queryParams}`).then((res)=> {
            if(res.success===true) {
                return res
            }
            else {
                return null
            }
        })
  }
  catch(e:any){
    HandleApiError(e);
            return null

  }

}
